import React, { useEffect, useState } from 'react'
import { getImageUrl } from '../../utils/images'
import { isEmail } from '../../helpers/string'
import { checkUserMigrated } from '../../service/BrandsService'
import { showMessage, showSpinner } from '../../utils/alerts'
import { VerfityPage } from './VerifyPage/Verify.Page'
import { loginUser } from '../../service/authServie'
import { useNavigate } from 'react-router-dom'

export const CheckuserExistsForm = ({emailId}) => {
  const [requiredEmailFlag, setRequiredEmailFlag] = useState(false)
  const [customerEmail, setCustomerEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [otpRecieved, setOtpRecieved] = useState(false)
  const navigate = useNavigate();


   const [enableAfterDelay, setEnableAfterDelay] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setEnableAfterDelay(true), 2000);
    return () => clearTimeout(timer);
  }, []);


  useEffect(()=>
  {
   

    if(emailId?.split("").includes("@"))
    {
      setCustomerEmail(emailId) 
    }
    else{
      setCustomerEmail("")
    }
  },[emailId])

  
  const checkLogin = async () => {
    const response = await loginUser(customerEmail)
    console.log('myresponse', response)
    if (response?.otpSend == true) {
      setOtpRecieved(true)
      setIsLoading(false)
      return
    }

    setIsLoading(false)


  }

  const HandleUserExists = async () => {
    setIsLoading(true)
    console.log('userEmail', customerEmail)

    const response = await checkUserMigrated(customerEmail)
    console.log('response recieved', response)
    if (response?.status === 200) {
      const result = response?.data
    //   if (result.Ismigrated === true) {
    //     if (!result.isPasswordchange) {
    //       localStorage.setItem('emiratesID', result?.message)
    //       checkLogin()
    //       return
    //     } else {
    //       showMessage(
    //         'Your password has already been updated',
    //         ' You can now proceed with logging in.'
    //       )
    //       setIsLoading(false)

    //       return
    //     }
    //   } else {
    //     showMessage(
    //       'We couldn’t find your account.',
    //       'No worries, create one quickly through the Hayak mobile app.'
    //     )
    //     setIsLoading(false)
    //   }
    // } else {
    //   showMessage(
    //     'Something went wrong.',
    //     response?.data?.message ? response?.data?.message : 'Please try again.'
    //   )
    //   setIsLoading(false)
    // }
    if (
      response?.status === 200 &&
      response?.data.otpSend === true
    ) {
      console.log("valid inside");
      showMessage(
        "Verification code sent!",
        "Please enter it along with your new password to reset your password."
      );
      navigate("/forgot-password/entercode", { state: { email: customerEmail, color: 'green' } });

      // setIsOTPSent(true)
      setIsLoading(false);

      return;
    } else if (
      response?.status === 200 &&
      response?.data.message.includes("Entered email does not exist")
    ) {
      showMessage(
        "Email address not found.",
        "The user with this email does not exist. Please check the email address or register for a new account."
      );
      setIsLoading(false);
      return;
    }
  } else {
    setIsLoading(false);
  }
  setIsLoading(false);
  }

  const HandleEmailChange = userInput => {
    setRequiredEmailFlag(true)
    setCustomerEmail(userInput)

    if (!isEmail(userInput)) {
      setRequiredEmailFlag(true)
    } else {
      setRequiredEmailFlag(false)
    }

    return
  }

  const backButton = () => {
    setOtpRecieved(false)
  }

  const handleBackToLogin = () => {
  window.location.href = `${window.location.origin}/`;
};
  return (
    <div class='align-center justify-content-center vh-100'>
      <div class='text-center w-100 px-60 px-lg-170'>
        <img
          src={getImageUrl('login-image.svg')}
          alt='img'
          class='w-100 mb-40 d-md-none'
        />
        <img src={getImageUrl('logo-dark.svg')} alt='img' class='w-60' />
        <h1 class='font-20 font-weight-600 my-25'>
          {otpRecieved ? '' : 'Verify User'}
        </h1>

        {otpRecieved ? (
          <VerfityPage
            email={customerEmail}
            backButton={backButton}
            checkLogin={checkLogin}
          />
        ) : (
          <form id='forgot'>
            <div class='login-field align-center text-left mb-3'>
              <div class='mr-3'>
                <img src={getImageUrl('icon-mail.svg')} alt='img' />
              </div>
              <div class='form-group'>
                <label>Registered email address*</label>
                <input
                  type='email'
                  name='registered-email'
                  value={customerEmail}
                  onChange={e => HandleEmailChange(e.target.value)}
                  class='form-control'
                  placeholder='Enter here...'
                />
                {requiredEmailFlag && (
                  <div className='validation-error'>
                    Please enter valid email address.
                  </div>
                )}
              </div>
            </div>
            <button
  type='button'
  disabled={
    !enableAfterDelay || requiredEmailFlag || isLoading || customerEmail?.length === 0
  }
  class='btn btn-default btn-block font-weight-600 rounded-12 py-10 mt-40 mb-4'
  onClick={() => HandleUserExists()}
>
  {isLoading ? 'Verifying...' : 'Verify email address'}
</button>

<button
  type='button'
  class='back-login-btn text-yellow font-16 font-weight-600 d-flex align-center mx-auto'
 onClick={handleBackToLogin}
>
  <span className="long-arrow text-yellow"></span>
  Back to Login
</button>

          </form>
        )}

        {/* <p class='font-10'>
          By using this service you agree to our
          <br />
          <span class='text-orange pointer mx-2'>
            <a
              href='https://hayak-dev.dafz.ae/web/hayak/terms-and-conditions'
              target='_blank'
              rel='noopener noreferrer'
            >
              terms of service
            </a>
          </span>
          &
          <span class='text-orange pointer mx-2'>
            <a
              href='https://hayak-dev.dafz.ae/web/hayak/privacy-policy'
              target='_blank'
              rel='noopener noreferrer'
            >
              privacy policy
            </a>
          </span>
        </p> */}
      </div>
    </div>
  )
}
